<template>
  <main class="main main--home">
    <div class="gradient-bg"/>

    <component
      v-for="(component, index) in components"
      :key="index"

      :is="component"
    />

    <ui-footer/>
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiFooter from 'ui/Footer';

// Pages
import Hero from 'pages/understandingYourReport/Hero';
import Info from 'pages/understandingYourReport/Info';
import Faq from 'pages/understandingYourReport/RootCanalFaq';
import BlueCallToAction from 'pages/understandingYourReport/BlueCallToAction';

export default {
  name: `view-understanding-your-report`,

  // Meta data
  metaInfo: {
    title: meta.home.title,
    meta: createMeta(meta.home.meta),
  },

  components: {
    UiFooter,
  },

  data() {
    return {
      components: {
        Hero,
        Info,
        Faq,
        BlueCallToAction,
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// UnderstandingYourReport.vue?d26aff64